var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-card",
    { staticClass: "m-2", staticStyle: { width: "500px" } },
    [
      _c(
        "div",
        { staticStyle: { display: "flex", "justify-content": "center" } },
        [
          _c("h2", { staticClass: "titulo" }, [
            _c("i", {
              staticClass: "far fa-exclamation-triangle",
              staticStyle: { color: "orange" }
            }),
            _vm._v(" "),
            _c("b", [_vm._v("Atenção")])
          ])
        ]
      ),
      _vm._v(" "),
      _c("hr"),
      _vm._v(" "),
      _c("div", [
        _c("p", [
          _vm._v(
            "\n      Seu cadastro não poderá ser finalizado, para se tornar\n      apto ao plano, seguem abaixo as qualificações necessárias,\n      ou você pode entrar em contato, por meio dos seguintes canais:\n    "
          )
        ]),
        _vm._v(" "),
        _c("p", [
          _vm._v("Email: "),
          _c("b", [_vm._v("comitegestorabc@sedap.pa.gov.br")])
        ]),
        _vm._v(" "),
        _c("p", [
          _vm._v("Whatsapp: "),
          _c("b", [_vm._v("(91) 3251-7914/7903/7906/7901")])
        ]),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "actionButtons" },
          [
            _c("CustomButton", {
              attrs: { text: "Qualificação ao plano ABC+" },
              on: { click: _vm.baixarCartilha }
            })
          ],
          1
        )
      ])
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-8dc922d2", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-8dc922d2","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/App/(authenticated)/modulos/cadastro/formulario-cadastro/praticas/form-praticas/NONE/NONE.vue
// module id = null
// module chunks = 